/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const GalleryHorizontalEnd = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M2 7v10" }],
    ["path", { d: "M6 5v14" }],
    ["rect", { width: "12", height: "18", x: "10", y: "3", rx: "2" }]
  ]
];

export { GalleryHorizontalEnd as default };
//# sourceMappingURL=gallery-horizontal-end.js.map
